import { Component, OnInit } from '@angular/core'
import { HouseholdStoreService, StoreService } from '@se-po/se-household-setup-data-access-store'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'

@Component({
  selector: 'se-create-household',
  templateUrl: './create-household.component.html',
  styleUrls: ['./create-household.component.scss']
})
export class CreateHouseholdComponent implements OnInit {

  public footerYear = new Date().getFullYear()
  public logo: string

  constructor(
    public analyticsService: AnalyticsService,
    public setupService: SetupBarService
  ) { }

  public ngOnInit() {
    this.logo = `${environment.uiThemes}/assets/latest/images/sportsengine-logo-color-black.svg`
  }
}
